module.exports = window["lodash"];